import { formatPhone } from '@chiroup/core/functions/format';
import { CalendarDays as CalendarDaysIcon } from 'lucide-react';

type Props = {
  // Phone for the patient's default (assigned) location. When absent we
  // fall back to a generic "contact us" message.
  phone?: string | null;
};

const NotSetup: React.FC<Props> = ({ phone }) => {
  const formattedPhone = phone ? formatPhone(phone, true) : '';

  return (
    <div className="px-4 py-16 sm:px-6 sm:py-24 md:grid md:place-items-center lg:px-8">
      <div className="max-w-md mx-auto text-center">
        <CalendarDaysIcon
          className="mx-auto size-12 text-gray-400 dark:text-gray-500"
          aria-hidden="true"
        />
        <p className="mt-4 text-base text-gray-600 dark:text-gray-300">
          {formattedPhone
            ? `We're not currently offering online scheduling. Please call us at ${formattedPhone} to schedule your appointment. We look forward to booking you!`
            : `We're not currently offering online scheduling. Please contact us to schedule your appointment. We look forward to booking you!`}
        </p>
      </div>
    </div>
  );
};

export default NotSetup;
